export class User {
  id: number
  isAuth: boolean
  name: string
  email: string
  isBeatmaker: boolean
  beatmaker: Beatmaker
  avatar: Avatar

  constructor(id: number = 0, avatar: Avatar = new Avatar(), isAuth: boolean = false) {
    this.id = id
    this.avatar = avatar
    this.isAuth = isAuth
  }
}

export interface Subscription {
  subscriptionPlan: number
  expirationDate: Date
}

export interface Beatmaker {
  subscription: Subscription
}

export class Avatar {
  small: string
  large: string
}
